import React from 'react';
import { IconChevron } from '../../../importCL';
import { ButtonWrapper } from '../../LinkWrapper/LinkWrapper';

const Pagination = ({ currentPage = 1, totalPages = 1, pageSize = 10 }) => {
    const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
    const showPreviousPage = currentPage > 1;
    const showNextPage = currentPage < totalPages;
    const nextPrevBtnTailwind: string = 'w-10 h-10 !rounded-lg mr-4 !p-0 bg-grey-alabaster !border-grey-alabaster';

    const getPageLink = (pageNumber: number) => {
        const startIndex = (pageNumber - 1) * pageSize + 1;
        const isActivePage = currentPage === pageNumber;
        const href = isActivePage ? 'javascript:void(0);' : `${window.location.href.replace(/&?start=\d+/g, '')}&start=${startIndex}`;
        return (
            <ButtonWrapper
                key={pageNumber}
                href={href}
                className={`!font-normal w-10 h-10 !rounded-lg mr-4 !p-0 ${!isActivePage ? 'bg-grey-alabaster !border-grey-alabaster !text-black' : ''}`}>
                    {pageNumber}
            </ButtonWrapper>
        );
    };

    return (
        <div className='flex  justify-center pt-8 w-[46.875rem]'>
            {showPreviousPage && (
                <ButtonWrapper
                    href={`${window.location.href.replace(/&?start=\d+/g, '')}&start=${((currentPage - 2) * pageSize + 1)}`}
                    className={nextPrevBtnTailwind}>
                        <IconChevron className='transform scale-x-[-1]' customColor='black' size='small'/>
                </ButtonWrapper>
            )}
            {pageNumbers.map((pageNumber) => {
                if (!showPreviousPage && pageNumber <= 3) {
                    return getPageLink(pageNumber);
                }

                // Display current page, previous page, and next page, except when page 2 is active show 2 3 4
                if (Math.abs(pageNumber - currentPage) <= 1 || (currentPage === 2 && pageNumber === 4)) {
                    if (pageNumber === 1) {
                        return null;
                    }
                    return getPageLink(pageNumber);
                }
                return null;
            })}
            {showNextPage && (
                <ButtonWrapper
                    href={`${window.location.href.replace(/&?start=\d+/g, '')}&start=${currentPage * pageSize + 1}`}
                    className={nextPrevBtnTailwind}>
                        <IconChevron customColor='black' size='small'/>
                </ButtonWrapper>
            )}
        </div>
    );
};

export default Pagination;
